export default class TcApiLocalization {
    constructor(localization) {
        this.localization = localization;
    }
    getLocale() {
        return this.localization.locale;
    }
    getCurrency() {
        return this.localization.currency;
    }
    getCurrencyIso() {
        return this.localization.currency_iso;
    }
    getDecimalDigits() {
        return this.localization.decimal_digits;
    }
    getMinGiftPrice() {
        return this.localization.min_gift_price;
    }
    getMobileRegex() {
        return this.localization.mobile_regex;
    }
    getMobileDefaultPrefix() {
        return this.localization.mobile_default_prefix;
    }
    getMobilePlaceholder() {
        return this.localization.mobile_placeholder;
    }
    getPostalCodePlaceholder() {
        return this.localization.postal_code_placeholder;
    }
    getPostalCodeRegex() {
        return this.localization.postal_code_regex;
    }
}
